import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Landmark, Loader2, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex emerald-bg pattern-overlay flex-col justify-between p-12 text-emerald-50">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-emerald-200 hover:text-white transition-colors" data-testid="login-back-home">
          <ArrowLeft size={16} /> Kembali ke website
        </Link>
        <div>
          <p className="font-arabic text-5xl gold-text mb-6">بِسْمِ اللّٰهِ الرَّحْمٰنِ الرَّحِيْمِ</p>
          <h1 className="text-4xl font-bold tracking-tight">Panel Pengurus<br />Masjid Al-Iman</h1>
          <p className="mt-4 text-emerald-200/90 max-w-md leading-relaxed">
            Kelola keuangan, kegiatan, jamaah, inventaris, dan informasi masjid secara amanah dan transparan.
          </p>
        </div>
        <p className="text-xs text-emerald-300/70">Dusun Banjarwaru RT. 05/06 Desa Kawali, Kec. Kawali, Kab. Ciamis 46253</p>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12 bg-background">
        <form onSubmit={submit} className="w-full max-w-sm space-y-6 rise" data-testid="login-form">
          <div className="flex items-center gap-3">
            <div className="h-11 w-11 rounded-2xl emerald-bg flex items-center justify-center text-[#d4af37]">
              <Landmark size={22} />
            </div>
            <div>
              <p className="text-xs font-semibold uppercase tracking-widest text-emerald-700">DKM Al-Iman</p>
              <h2 className="text-xl font-bold text-emerald-950">Masuk Admin</h2>
            </div>
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="admin@masjid.id" data-testid="login-username-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Kata Sandi</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="••••••••" data-testid="login-password-input" />
          </div>
          {error && (
            <p className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2" data-testid="login-error">
              {error}
            </p>
          )}
          <Button type="submit" className="w-full rounded-full h-11 emerald-bg hover:bg-[#145c48]" disabled={loading} data-testid="login-submit-btn">
            {loading ? <Loader2 className="animate-spin" size={18} /> : "Masuk"}
          </Button>
          <Link to="/" className="lg:hidden block text-center text-sm text-emerald-800 underline" data-testid="login-back-home-mobile">
            Kembali ke website
          </Link>
        </form>
      </div>
    </div>
  );
}
